/**
 * This function returns the Funeral Home Ids which is associated with Forest Lawn CA.
 * These FH does not want to use AMPUrl on the page.
 * @return {Array} List of Ids
 */
export default function getForestLawnFuneralHomeIds() {
    return [2676, 4501, 4502, 4503, 4504, 4505, 24101, 20227]
}


// WEBPACK FOOTER //
// ./src/data/ForestLawnFuneralHomeIds.js